import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FolderIcon from "components/lib/Shared/Icons/Folder";
import LadderIcon from "components/lib/Shared/Icons/Ladder";
import PointerIcon from "components/lib/Shared/Icons/Pointer";
import SidebarItem from "./SidebarItem";
import { Roles_Permissions_Constants } from "config/roles-permissions";
import { Constants } from "config/constants";
import useComplianceAccess from "hooks/useComplianceAccess";

function Sidebar({ selectedTab, setSelectedTab }) {
  const history = useHistory();
  const { dashboardRoles, dashboardPermissions, designation } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { canAccessCompliance } = useComplianceAccess();
  const viewRestrictedData = dashboardPermissions.some(
    (permission) =>
      permission.name ===
      Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA
  );
  const { company } = useSelector((state) => state.companySlice);

  const { isUpdateHistory } = useSelector(
    (state) => state.transferYourBusinessSlice
  );

  const auditTabs = [
    { id: "billing", label: "Billing", disabled: false },
    {
      id: "accountSettings",
      label: "Account Settings",
      disabled:
        (!dashboardRoles.some(
          (role) =>
            role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
        ) &&
          !dashboardPermissions.some(
            (permission) =>
              permission.name ===
              Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.MANAGE_USERS
          )) ||
        company?.status === "Draft",
    },

    { id: "notifications", label: "Notifications", disabled: true },
    {
      id: "transactions",
      label: "Transactions",
      disabled: isUpdateHistory ? false : company?.status === "Draft",
    },
    { id: "auditTrail", label: "Audit Trail", disabled: true },
  ];
  const documentPermissionValues = Object.values(
    Roles_Permissions_Constants.DOCUMENT_PERMISSIONS
  );
  const hasDocumentPermissions = dashboardPermissions.some((docPermission) =>
    documentPermissionValues.includes(docPermission.name)
  );
  const generalTabs = useMemo(() => {
    const baseTabs = [
      {
        id: "businessDetails",
        label: "Business Details",
        //disabled: company?.status === "Draft",
      },
    ];
    if (
      ![Constants.APPLICANT_CAPACITIES.AUTHORIZED_PERSON].includes(
        designation
      ) ||
      viewRestrictedData ||
      hasDocumentPermissions
    ) {
      baseTabs.push({
        id: "minuteBook",
        label: "Minute Book",
        disabled: company?.status === "Draft",
      });
    }
    return baseTabs;
  }, [viewRestrictedData, designation, documentPermissionValues]);

  const managementTabs = useMemo(() => {
    const tabs = [];

    if (canAccessCompliance) {
      tabs.push({ id: "compliance", label: "Compliance Tracker" });
    }

    tabs.push({
      id: "companies",
      label: "Companies",
      disabled: !dashboardRoles?.some(
        (role) =>
          role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
      ),
    });

    tabs.push({ id: "manageYourCompany", label: "Manage your company" });

    tabs.push({
      id: "contracts",
      label: "Contracts",
      disabled: true,
      comingSoon: true,
    });

    tabs.push({ id: "history", label: "History" });

    return tabs;
  }, [dashboardRoles, canAccessCompliance]);

  const handleTabClick = (item) => {
    if (item?.disabled) return null;
    if (item?.href) return history.push(item.href);
    else setSelectedTab(item);
  };

  return (
    <div className="col-span-4 md:col-span-1 pt-8">
      <div>
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <FolderIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">General</span>
        </h4>
        <ul className="ml-10">
          {generalTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          ))}
        </ul>
      </div>
      <div className="border-t pt-2">
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <LadderIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">Management</span>
        </h4>
        <ul className="ml-10">
          {managementTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          ))}
        </ul>
      </div>
      <div className="border-t pt-2">
        <h4 className="mb-2 text-sflPrimary font-medium flex items-center">
          <PointerIcon className="w-5 h-5" aria-hidden="true" />
          <span className="pl-2">Audit</span>
        </h4>
        <ul className="ml-10">
          {auditTabs.map((item) => (
            <SidebarItem
              key={item.label}
              item={item}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
